<template lang="pug">
div.format
  el-row.padding-bottom(:gutter="30")
    el-col(:span="24")
      app-divider(label="Área de interesse")
    el-col.inputDiv(:span="12")
      app-label(label="Número do recibo do CAR:")
      validation-provider(rules="required|car", v-slot="{ errors }", name="Imóvel/N° do CAR")
        el-input.input(
          v-model="imovel.numeroReciboCar",
          name="Número do recibo do CAR",
          v-mask="customMask",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="6")
      app-label(label="Tempo de ocupação (em anos):")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Tempo ocupação")
        .tempo-ocupacao.input
          .select-size
            el-input.input(
              v-model="imovel.tempoOcupacao",
              size="mini",
              name="Tempo ocupação",
              min="0",
              v-mask="numberMask",
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}
          span ano(s)
    el-col.inputDiv(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Ocupações Anteriores")
        app-label(label="Há ocupantes anteriores?")
        el-radio-group.radio-group(
          name="Ocupações Anteriores",
          v-model="imovel.ocupantesAnteriores"
          :class="{'erro' : errors.length}"
        )
          el-radio.radio(:label='true') Sim
          el-radio.radio(:label='false') Não
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Imóveis rurais no Pará")
        app-label(:label="'Possui outros imóveis rurais no ' + ESTADO + '?'")
        el-radio-group.radio-group(
          name="Imóveis rurais no Pará",
          v-model="imovel.possuiImovel"
          :class="{'erro' : errors.length}"
        )
          el-radio.radio(:label='true') Sim
          el-radio.radio(:label='false') Não
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Conflitos no imóvel")
        app-label(label="Há conflitos no imóvel?")
        el-radio-group.radio-group(
          name="Conflitos no imóvel",
          v-model="imovel.conflitos"
          :class="{'erro' : errors.length}"
        )
          el-radio.radio(:label='true') Sim
          el-radio.radio(:label='false') Não
        span.help.erro {{ errors[0] }}

  el-row(
    :gutter="30",
    v-if="imovel.conflitos"
  )
    el-col(:span="12")
      app-label(
        label="Nº do processo judicial:",
        :required="false"
      )
      el-col(:span="24", style="padding: 0;")
        validation-provider(v-slot="{ errors }", name="Imóvel/Conflitos no imóvel")
          el-input.input(
            name="Nº do processo judicial",
            maxlength="100",
            v-model="imovel.numeroProcessoJudicial",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

</template>

<script>
import { TheMask } from 'vue-the-mask'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import { mapState } from 'vuex'

export default {

  components: {
    AppLabel,
    AppDivider,
    TheMask
  },

  props: {
    imovel: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    })
  },

  data () {
    return {
      customMask: {
        mask: 'AA-NNNNNNN-FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF',
        tokens: {
          A: {
            pattern: /[a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          },
          N: {
            pattern: /\d/
          },
          F: {
            pattern: /[0-9a-fA-F]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      },
      numberMask: {
        mask: 'NNN',
        tokens: {
          N: {
            pattern: /\d/
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.format {
  text-align: left;
}
.el-row {
  margin-bottom: 20px;
}
.select-size {
  width: 80px;
}

.radio {
  margin: 5px;
}

.tempo-ocupacao {
  display: flex;
  align-items: baseline;

  span {
    margin-left: 5px;
  }
}

@media (max-width: 780px) {
  .inputDiv {
    width: 100%;
  }

  .labelDiv {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppImovelAreaInteresse.vue